<template>
  <div class="hello">
    <div>
      <div class="input">
      
        <van-field :left-icon="`${img}icom.png`" type="digit" @focus="focus" maxlength="11" @input="input" v-model="value" placeholder="请输入手机号" class="inputs" />
      </div>
    <div @click="open">
        <img :src="`${imgbtn}`" alt="" class="btn" :style="{ 
            width: pxToVw(btnWidth), 
            height: pxToVw(btnHeight) 
          }"  />
    </div>
       <div class="check" >
        <div ref="checkboxWrapper" class="checkbox-wrapper">
          <van-checkbox v-model="checked" @change="changebox" icon-size="15px">
            <div style="width: 1px;"></div>
          </van-checkbox>
        </div>

   <div class="boss" >
  <span class="agreest" :style="colorx">我已同意并阅读</span>
  <span v-for="(item, index) in agree" :key="index" class="agreest" :style="colorx1" @click="change(item)">
     <span>{{ item.name}}</span>
  </span>
</div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { userApi, traceApi } from '@/api/index.js'
import CryptoJS from 'crypto-js'
import decryptData from '@/utils/decryptData.js'
import md5 from "@/utils/md5.js"
import JSEncrypt from 'jsencrypt'
import { mixedKey, swapsArray } from '../utils/key.js'
import { restoreShuffle } from '../utils/arrayUtils.js'
import params from "@/utils/param.js"
import { debounce } from 'lodash';
import store from '@/store/index.js'

export default {
  name: "ConTent",
  props: {
    img: String,
    imgbtn: String,
    color: String,
    colorx: String,
    colorx1: String,
     showx:'',
    agree: Array,
    a: String,
    productCode: String,
    checkboxColor: {
      type: String,
      default: '#fff'
    },
      // 新增：按钮宽度（默认280px）
    btnWidth: {
      type: [Number, String],
      default: 280
    },
    // 新增：按钮高度（默认60px）
    btnHeight: {
      type: [Number, String],
      default: 60
    },
    // 可选：设计稿宽度（和postcss-px-to-viewport配置一致）
    designWidth: {
      type: Number,
      default: 375
    }
  },
  data() {
    return {
      checkMove:false,
      param: "",
      value: '',
      checked: "",
      key: '',
      iv: "",
      data: "",
      decrypt: "",
      judgeType: '',
      env: "",
    };
  },
  watch: {
    checkboxColor: {
      immediate: true,
      handler(newColor) {
        // 确保组件已挂载
        this.$nextTick(() => {
          this.applyCheckboxColor(newColor)
        })
      }
    }
  },
  mounted() {
    // 组件挂载后立即应用颜色
    this.applyCheckboxColor(this.checkboxColor)

    // 监听DOM变化，确保复选框渲染后应用样式
    this.observeCheckboxDOM()
  },
  created() {

    if (/Android/.test(navigator.userAgent)) {
      this.judgeType = 'android'
    }
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      this.judgeType = 'ios'
    }
    this.getEnv()
    if (localStorage.getItem('mobile')) {
      this.value = localStorage.getItem('mobile')
    }
    if (params.getParam(this.$route.query)) {
      this.param = params.getParam(this.$route.query)
    }
  },
  methods: {
     pxToVw(px) {
      const numPx = Number(px);
      // 容错处理：非数字/小于等于1px不转换
      if (isNaN(numPx) || numPx <= 1) return `${px}px`;
      // 计算vw：(px值 / 设计稿宽度) * 100
      const vwValue = (numPx / this.designWidth) * 100;
      // 保留2位小数，避免精度问题
      return `${vwValue.toFixed(2)}vw`;
    },
    focus(){
      this.point(3)
    },
    // 应用复选框颜色的核心方法
    applyCheckboxColor(color) {
      const finalColor = color || '#fff'
      // 方法2: 直接设置内联样式作为备用
      this.$nextTick(() => {
        const icons = document.querySelectorAll('.hello .van-checkbox__icon .van-icon')
        icons.forEach(icon => {
          icon.style.setProperty('border-color', finalColor, 'important')
          icon.style.setProperty('background-color', 'transparent', 'important')
        })

        const checkedIcons = document.querySelectorAll('.hello .van-checkbox__icon--checked .van-icon')
        checkedIcons.forEach(icon => {
          icon.style.setProperty('border-color', finalColor, 'important')
           icon.style.setProperty('color', finalColor, 'important')
          icon.style.setProperty('background-color', 'transparent', 'important')
        })

        const checkedBefore = document.querySelectorAll('.hello .van-checkbox__icon--checked .van-icon::before')
        // 伪元素需要通过样式表设置
      })
    },

    // 监听复选框DOM变化
    observeCheckboxDOM() {
      const observer = new MutationObserver(() => {
        this.applyCheckboxColor(this.checkboxColor)
      })

      if (this.$refs.checkboxWrapper) {
        observer.observe(this.$refs.checkboxWrapper, {
          childList: true,
          subtree: true,
          attributes: true
        })
      }
    },

    getEnv() {
      const ua = navigator.userAgent.toLowerCase()
      const isWechat = ua.includes('micromessenger')
      const isAlipay = ua.includes('alipayclient')
      const isAndroid = /android/.test(ua)
      const isIOS = /ipad|iphone|ipod/.test(ua)

      // 微信环境
      if (isWechat) {
        if (isAndroid) {
          // userApi.fcFast({ userAgent: navigator.userAgent }).then(res => {
          //   this.env = res.support ? '0' : '1'
          //   this.$emit('env-change', this.env)
          // })
          this.env='1'
          this.$emit('env-change', this.env)
          return
        }
        if (isIOS) {
          this.env = '2'
          this.$emit('env-change', this.env)
          return
        }
      }

      // 支付宝环境
      if (isAlipay) {
        this.env = '3'
        this.$emit('env-change', this.env)
        return
      }

      // 其他环境
      this.env = '4'
      this.$emit('env-change', this.env)
    },

    point(e, n) {
      traceApi.event({
        t: localStorage.getItem('traceId'),
        e: e,
        f: n
      })
    },

    jump(urls) {
      if (this.env == 0) {
        userApi.saveFastAppUrl({ url: urls }).then(res => {
          this.$emit('keys', JSON.stringify({ key: res.key }));
          this.$emit('flagx', true);
        });
        return;
      }

      const jumpMap = {
        1: `https://gw.zzqz2024.com/am/api/associateMember/command/evokeBroswer?redirect=${encodeURIComponent('https://web.78keji.cn/newbluexy/#/?url=' + urls)}`,
        2: `https://ulink.alipay.com/?scheme=${encodeURIComponent('alipays://platformapi/startapp?appId=20000067&url=' + encodeURIComponent(urls))}`,
        3: urls,
      };

      window.location.href = jumpMap[this.env] ||
        `alipays://platformapi/startapp?appId=20000067&url=${encodeURIComponent(urls)}`;
    },

    pay: debounce(function () {
      this.$store.commit('setLoading', true)
      this.point(9)
      userApi.generateToken({
        channelCode: this.a,
        productCode: this.productCode,
        mobile: this.value,
        traceId: localStorage.getItem('traceId')
      }).then((res) => {
        
        if (res.reason == 0) {
          this.key = CryptoJS.enc.Utf8.parse(md5.hex_md5(res.i))
          this.iv = CryptoJS.enc.Utf8.parse(res.i + '000')
          this.data = res.t

          userApi.register({
            mobile: this.value
          }).then((res1) => {
            localStorage.setItem('token', res1.accessToken);
            const encryptedData = CryptoJS.enc.Base64.parse(this.data);
            this.decrypt = decryptData.decryptData(encryptedData, this.key, this.iv)

            userApi.getchannel({
              channelCode:this.a
            }).then((res2) => {
              const decrypt = new JSEncrypt();
              decrypt.setPrivateKey(restoreShuffle(mixedKey.split('/'), swapsArray).join('/'))
              const decryptex = decrypt.decrypt(res2);
              const decryptexs = CryptoJS.enc.Utf8.parse((decryptex))

              var content = JSON.stringify({
                mobile: this.value,
                paymentMethod: "1",
                orderType: "1",
                channelCode: this.a,
                productCode: this.productCode,
                deviceId: navigator.userAgent,
                judgeType: this.judgeType,
                param: this.param,
                redirectUrl: window.location.href
              })
              const timestamp = Math.floor(new Date().getTime())
              var encryptResult = decryptData.cryptData(content, decryptexs, CryptoJS.enc.Utf8.parse(timestamp + '000'))

              userApi.signOrder({
                channelCode: this.a,
                data: encryptResult,
                iv: timestamp + '000',
                t: this.decrypt,
                traceId: localStorage.getItem('traceId')
              }).then((res3) => {
                if (res3.reason == 0) {
                  this.$store.commit('setLoading', false)
                  let key = CryptoJS.enc.Utf8.parse(md5.hex_md5(this.decrypt))
                  let url = decryptData.decryptData(
                    CryptoJS.enc.Base64.parse(res3.encryptData),
                    key,
                    CryptoJS.enc.Utf8.parse(timestamp + '000')
                  )

                  let urls = JSON.parse(url).extInfo.signUrl
                  this.jump(urls)
                }
              })
            })
          })
        }
      })
    }, 300),

    open() {
   
      if (this.env == '0') {
        if (!/^1[3456789]\d{9}$/.test(this.value)) {
          this.$toast('请输入正确的手机号')
        } else {
          this.pay()
        }
      } else {
        if (!/^1[3456789]\d{9}$/.test(this.value)) {
          return this.$toast('请输入正确的手机号');
        }

        if (this.checked == true) {
          this.pay()
        } else {
          this.$emit('flagx', true)
        }
      }
    },

    changebox(e) {
      if (e == true) {
        traceApi.event({
          t: localStorage.getItem('traceId'),
          obj: 5
        })
      }
    },

   change(e) {
      console.log(e)
      if (e.url) {
        window.location.href = e.url
      } else {
        console.log(e.id)
        if (e.id == 1) {
          this.$emit('ys', true)
        }
        else if (e.id == 3) {
          this.$emit('rule', true)
        }
      }
     
    },

 input() {
  // ———— 核心：根据输入长度判断是否下移 ————
  this.checkMove = this.value.length === 11;

  // 下面是你原来的逻辑，完全不动
  if (this.value.length == 11) {
    if (!/^1[3456789]\d{9}$/.test(this.value)) {
      return this.$toast('请输入正确的手机号');
    }
    traceApi.event({
      t: localStorage.getItem('traceId'),
      e: 4,
      obj: this.value
    })
    localStorage.setItem('mobile', this.value)
    this.$nextTick(() => {
      const inputElement = this.$el.querySelector('.van-field__control')
      if (inputElement) {
        inputElement.blur()
      }
    })
    this.$emit('showchange', false)
    if (this.checked == true) {
      this.open()
    } else {
      this.$emit('flagx', true)
    }
  }else{
    this.$emit('showchange', true)
  }
}
  }
}
</script>

<style scoped>
@keyframes butChange {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.hello {
  font-size: 20px;
  max-width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
}

.btn {
  animation: butChange 1s infinite;
  margin-top: 19px;
  margin-left: auto;
  margin-right: auto;
  object-fit: contain;
}

.check {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0 auto;
  margin-top: 10px; /* 默认 */
  width: 90%;
  max-width: 320px;
  justify-content: flex-start;
  box-sizing: border-box;
  line-height: 14px;
  transition: all 0.2s ease;
}
.check.move {
  margin-top: 40px !important; /* 输入11位时 */
}

.checkbox-wrapper {
  margin: 0 4px 0 0;
  flex-shrink: 0;
  padding: 0;
  display: flex;
  align-items: center;
  height: 14px;
}

.boss {
  flex: 1;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  margin: 0;
  padding: 0;
  line-height: 4px;
  text-align: left;
  overflow-wrap: break-word;
  box-sizing: border-box;
  font-size: 12px;
}

.agreest {
  line-height: 16px;
  display: inline;
  white-space: normal;
  word-break: break-all;
  cursor: pointer;
  margin: 0 !important;
  padding: 0 !important;
}

.agreest::after {
  content: none !important;
}

/* 外层容器样式（维持原有宽度） */
.inputs {
  width: 280px;
  background: #FFFFFF;
  border-radius: 25px;
  font-size: 18px;
  line-height: 26px;
  margin: 0 auto;
  display: block;
  box-sizing: border-box;
  border: 1px solid #FC1A2B;
  display: flex;
  align-items: center;
}

/* ====================== 核心修改 ====================== */
/* 1. 左边图标右移 10px */
:deep(.inputs .van-field__left-icon) {
  padding-left: 10px !important;
  position: relative;
  
}

/* 2. 图标右侧添加竖线分割线 */
:deep(.inputs .van-field__left-icon)::after {
  content: "";
  position: absolute;
  right: -8px;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 16px;
  background-color: #1676FF; /* 与边框同色，可自行修改 */
  opacity: 0.13
}

/* 3. 输入框内容右移，避免贴着竖线 */
:deep(.inputs .van-field__control) {
  padding-left: 15px !important;
  padding-right: 0 !important;
  box-sizing: border-box;
}

/* 4. placeholder 同步偏移 */
:deep(.inputs .van-field__placeholder) {
  padding-left: 15px !important;
}
/* ==================================================== */

.check * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.hello>div {
  margin: 0;
  padding: 0;
}

@media (max-width: 375px) {
  .check {
    width: 95%;
  }
  .checkbox-wrapper {
    margin: 0 3px 0 0;
  }
}

@media (max-width: 320px) {
  .check {
    width: 95%;
  }
  .agreest {
    line-height: 16px;
  }
}

.agreement-confirm-main-box {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: url("https://qiming-1308147483.cos.ap-chengdu.myqcloud.com/doc%2Fpinzhi_shenghuo_huiyuan_quanyi%2Fcommon%2Flogin-shadow-bg.png") repeat;
  z-index: 3;
  .agreement-confirm-box {
    border-radius: 10px;
    background-color: #fff;
    padding: 15px;
    width: 80%;
    box-sizing: border-box;
    padding: 31px 29px 19px;
  }
}

.inputn {
  height: 40px;
  border-radius: 6px;
  margin-top: 8px;
  border: 1px solid #EBEBEB;
}

.van-cell {
  line-height: 24px;
  padding: 10px 16px 10px 6px;
}

.van-cell__title {
  text-align: left;
}

.img {
  width: 21px;
  height: 21px;
}

.imgs {
  width: 24px;
  height: 24px;
  margin-top: 4px;
}

.btx {
  width: 100%;
  height: 40px;
  background: #FF7E00;
  border-radius: 5px;
  margin-top: 29px;
  color: #fff;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.van-checkbox__icon) {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  flex: none;
  height: 1em;
  font-size: 15px !important; 
  line-height: 1em;
  cursor: pointer;
}
/* 1. 左边图标左间距10px + 放大图标 */
:deep(.inputs .van-field__left-icon) {
  padding-left: 10px !important;
  position: relative;
  /* 放大图标 */
  font-size: 22px !important;
}
:deep(.inputs .van-field__left-icon img) {
  width: 24px !important;
  height: 24px !important;
}

/* 2. 图标右侧竖线分割线 */
:deep(.inputs .van-field__left-icon)::after {
  content: "";
  position: absolute;
  right: -8px;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 18px;
  background-color: #FC1A2B;
}

/* 输入框内边距 */
:deep(.inputs .van-field__control) {
  padding-left: 15px !important;
  padding-right: 0 !important;
}
:deep(.inputs .van-field__placeholder) {
  padding-left: 15px !important;
}
</style>